<template>
  <div>
    <!-- <pre class="text-light">     
      {{ getAllTrades }}
    </pre> -->

    <!-- DELETE DIALOG TRADES/DIVIDENDS -->
    <base-dialog
      :show="!!showDeleteDialog"
      :show-ok="false"
      title="Delete record?"
      @close="handleCloseShowDelete"
    >
      <div class="tx-light mb-2">
        Are you sure you want to delete record
        <span class="text-warning"> {{ deleteTitleGuid }} ?</span>
        <div v-html="deleteTitleGuidDesc"></div>

        <div class="float-end mt-4">
          <base-button @click="handleCloseShowDelete">Cancel</base-button>
          <base-button @click="deleteIdActual">Delete</base-button>
        </div>

        <div>&nbsp;</div>
        <div>&nbsp;</div>
      </div>
    </base-dialog>

    <!-- <pre class="text-light">
  {{ getAllDividends }}
    </pre> -->

    <div class="accordion accordion-flush" id="accordionExample">
      <!-- IMPORT -->
      <div class="accordion-item bg-dark">
        <h2 class="accordion-header" id="headingOne">
          <button
            class="accordion-button collapsed bg-dark"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="false"
            aria-controls="collapseOne"
          >
            <h4 class="text-warning mt-1">Import</h4>
          </button>
        </h2>

        <div
          id="collapseOne"
          class="accordion-collapse collapse"
          aria-labelledby="headingOne"
        >
          <div class="accordion-body">
            <!-- TRADES IMPORT -->
            <div class="row mb-2">
              <div class="col-2">
                <base-button
                  type="button"
                  class="form-control"
                  @click="importTrades()"
                  >Import Trades</base-button
                >
              </div>

              <div class="col-10 text-light">
                <h5>
                  Use format [Interactive Brokers -> Flex Queries ->
                  Trades-new]:
                </h5>
                <div class="text-warning" v-html="escapedXmlTrades"></div>
              </div>
            </div>
            <br />

            <!-- PRICES IMPORT -->
            <div class="row mb-2">
              <div class="col-2">
                <base-button
                  type="button"
                  class="form-control"
                  @click="importPrices()"
                  >Import Prices</base-button
                >
              </div>

              <div class="col-10 text-light">
                <h5>
                  Copy from ETF-GoogleFinance -> page For COPY -> columns A,B,C
                  to this textbox
                </h5>
              </div>
            </div>

            <br />

            <!-- DIVIDENDS IMPORT -->
            <div class="row mb-2">
              <div class="col-2">
                <base-button
                  type="button"
                  class="form-control"
                  @click="importDividends()"
                  >Import Dividends</base-button
                >
                <!-- <base-button
                  type="button"
                  class="form-control"
                  @click="getYearDividend"
                  >Import Dividends1</base-button
                > -->
              </div>

              <div class="col-10 text-light">
                <h5>
                  Use format [Interactive Brokers -> Statements ->
                  Dividende-Jernej] CSV:
                </h5>
                <!-- <div class="text-warning">
                  Dividends,Data,USD,2024-01-11,M3P(US58463J3041) Cash Dividend
                  USD 0.15 per Share (Ordinary Dividend),292.5,
                </div> -->

                <div class="col-10 text-light">For dividends in EUR:</div>
                <div class="text-warning">
                  Dividends,Data,EUR,2025-03-06,ICAD(FR0000035081) Cash Dividend
                  EUR 1.16 per Share (Ordinary Dividend),29,
                </div>
                <div class="text-warning">
                  Dividends,Data,EUR,2025-03-06,ICAD(FR0000035081) Cash Dividend
                  EUR 1.00 per Share (Return of Capital),25,
                </div>
                <div class="text-warning">
                  Withholding Tax,Data,EUR,2025-03-06,ICAD(FR0000035081) Cash
                  Dividend EUR 1.16 per Share - FR Tax,-7.25,
                </div>

                <div class="col-10 text-light">
                  For dividends in other currencies [bold text is actually EUR]:
                </div>

                <div class="text-warning">
                  Forex P/L Details,Data,Forex,EUR,JXN(US46817M1071) Cash
                  Dividen..,"2025-03-20,
                  20:20:00",USD,4,&nbsp;<b>3.68548,</b>&nbsp;-3.68548,0,C
                </div>

                <br />

                <div class="text-warning">
                  <b>CAUTION! Import for whole year!!!</b>
                </div>
              </div>
            </div>

            <!-- PRICES ZACKS HTML TABLE -->
            <!-- <div class="row mb-2">
              <div class="col-2">
                <base-button
                  type="button"
                  class="form-control"
                  @click="importZacks()"
                  >Import ZACKS</base-button
                >
              </div>
            </div> -->

            <div class="col-3 align-items-start mb-2"></div>

            <textarea
              id="importarea"
              v-model="importText"
              style="width: 100%; height: 300px"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- SEARCH -->
      <base-card>
        <h5 class="mb-3 ms-1">Search in both lists</h5>

        <div class="row mb-2 ms-2">
          <div class="col-6 px-0">
            <table>
              <tr>
                <td>
                  <base-text-search v-model="searchText"></base-text-search>
                </td>
                <td class="align-bottom">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="searchText = ''"
                  >
                    <font-awesome-icon icon="fa-solid fa-solid fa-trash" />
                  </button>
                </td>
                <td>
                  <div class="form-check form-switch ms-3">
                    <label class="form-check-label" for="flexSwitchSymbolOnly"
                      >Search on symbol only</label
                    >
                    <input
                      id="flexSwitchSymbolOnly"
                      @click="searchOnSymbolOnly($event)"
                      class="form-check-input"
                      type="checkbox"
                      :checked="searchOnlySymbol"
                    />
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <!-- <div class="container">
          <div class="row mb-2 align-items-end">
            <div class="col-3 text-end px-0">
              <base-text-search v-model="searchText"></base-text-search>
            </div>
            <div class="col-9 px-1">
              <button class="btn btn-danger btn-sm" @click="searchText = ''">
                <font-awesome-icon icon="fa-solid fa-solid fa-trash" />
              </button>
            </div>
          </div>
        </div> -->
      </base-card>

      <!-- DASHBOARD -->
      <div class="accordion-item bg-dark mt-2">
        <h2 class="accordion-header" id="headingTwo">
          <button
            class="accordion-button collapsed bg-dark"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
          >
            <h4 class="text-warning mt-1">Dashboard</h4>
          </button>
        </h2>

        <div
          id="collapseTwo"
          class="accordion-collapse collapse"
          aria-labelledby="headingTwo"
        >
          <!-- DASHBOARD -->
          <div class="accordion-body">
            <!-- DATE AND PROFIT -->
            <base-card class="bg-dark text-warning">
              <section>
                <h5 class="mb-3 ms-1">Select date</h5>
                <base-card>
                  <base-date-picker
                    @ondatechange="ondatechangehere"
                    id="selectedDate"
                    :year-range="[2010, 2030]"
                    :min-date="minDate"
                    :max-date="maxDate"
                    :model-value="priceDate"
                    :allowed-dates="allowedDates"
                  >
                  </base-date-picker>
                </base-card>
                <base-card class="bg-dark text-warning">
                  <div>
                    Sum Profit:&nbsp;&nbsp;<b :class="setclass(sumProfit)">{{
                      sumProfit
                    }}</b>
                  </div>
                </base-card>
              </section>
            </base-card>

            <base-card class="bg-dark">
              <!-- <h5 class="mb-3 ms-1">Dashboard</h5> -->
              <table class="table table-striped table-dark">
                <thead>
                  <tr class="text-warning">
                    <th>
                      <a class="jr-link" :href="null" @click="fOrder('symbol')"
                        >Symbol
                      </a>
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="fOrder('description')"
                        >Description
                      </a>
                    </th>

                    <th style="text-align: right">
                      <a
                        style="text-align: right"
                        class="jr-link"
                        :href="null"
                        @click="fOrder('sum')"
                        >Quantity</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="fOrder('priceNow')"
                        >Price Now</a
                      >
                    </th>
                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="fOrder('valueNow')"
                        >Value Now</a
                      >
                    </th>
                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="fOrder('sumMoney')"
                        >Sum Buy</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a class="jr-link" :href="null" @click="fOrder('profit')"
                        >Profit</a
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <trade-dashboard-item
                    v-for="item in getDashboard"
                    :key="item.symbol"
                    :index="item.symbol"
                    :symbol="item.symbol"
                    :description="item.description"
                    :sum="item.sum"
                    :sumMoney="item.sumMoney"
                    :valueNow="item.valueNow"
                    :profit="item.profit"
                    :priceNow="item.priceNow"
                  >
                  </trade-dashboard-item>

                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td :class="setclass(sumProfit)" style="text-align: right">
                      <b>{{ sumProfit }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </base-card>
          </div>
        </div>
      </div>

      <!-- TRADES -->
      <div class="accordion-item bg-dark mt-2">
        <h2 class="accordion-header" id="headingThree">
          <button
            class="accordion-button collapsed bg-dark"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
          >
            <h4 class="text-warning mt-1">Trades</h4>
          </button>
        </h2>

        <div
          id="collapseThree"
          class="accordion-collapse collapse"
          aria-labelledby="headingThree"
        >
          <!-- TRADES -->
          <div class="accordion-body">
            <!-- SEARCH TRADES ON FIREBASE -->
            <base-card>
              <h5 class="mb-3 ms-1">Search Trades on Server</h5>
              <div>
                <base-spinner v-if="isLoading"
                  ><template #spinnerslot
                    ><h4 class="text-light">Loading...</h4></template
                  ></base-spinner
                >
              </div>

              <div class="container" style="margin: 20px">
                <table style="width: auto">
                  <tr>
                    <td style="text-align: right; padding-bottom: 8px">
                      <base-text-search
                        v-model="searchTrades"
                        title="Symbol"
                      ></base-text-search>
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style="text-align: right; padding-bottom: 8px">
                      <base-text-search
                        v-model="searchTradesDate"
                        title="Date"
                      ></base-text-search>
                    </td>
                    <td>&nbsp;[ YYYY | YYYY-YYYY | YYYY-MM | YYYY-MM-DD ]</td>
                  </tr>
                  <tr>
                    <td style="text-align: right">
                      <base-button @click="searchTradesFirebase"
                        >Search <font-awesome-icon icon="fa-magnifying-glass"
                      /></base-button>
                    </td>
                    <td>&nbsp;</td>
                  </tr>
                </table>
              </div>

              <!-- <div class="container">
          <div class="row mb-2 align-items-end">
            <div class="col-3 text-end px-0">
              <base-text-search v-model="searchText"></base-text-search>
            </div>
            <div class="col-9 px-1">
              <button class="btn btn-danger btn-sm" @click="searchText = ''">
                <font-awesome-icon icon="fa-solid fa-solid fa-trash" />
              </button>
            </div>
          </div>
        </div> -->
            </base-card>

            <base-card class="bg-dark">
              <section>
                <!-- <h5 class="mb-3 ms-1">Trades</h5> -->
                <!-- <base-card v-if="isLoading">
        <div v-if="isLoading">
          <base-spinner></base-spinner>
        </div>
      </base-card> -->

                <base-card class="bg-dark text-light">
                  <div>Number of records: {{ getAllTrades.length }}</div>
                </base-card>

                <!-- radio button SELL BUY -->
                <base-card class="text-warning">
                  <div>
                    <div class="row ms-1">
                      <div class="form-check form-switch col-sm-2">
                        <label class="form-check-label" for="flexSwitchSell"
                          >Show SELL Only</label
                        >
                        <input
                          id="flexSwitchSell"
                          @click="showOnlySell($event)"
                          class="form-check-input"
                          type="checkbox"
                          :checked="onlySellActive"
                        />
                      </div>

                      <div class="form-check form-switch col-sm-2">
                        <label class="form-check-label" for="flexSwitchBuy"
                          >Show BUY Only</label
                        >
                        <input
                          id="flexSwitchBuy"
                          @click="showOnlyBuy($event)"
                          class="form-check-input"
                          type="checkbox"
                          :checked="onlyBuyActive"
                        />
                      </div>

                      <!-- fast links for months -->
                      <div class="col-sm-8">
                        <year-month-link
                          v-for="item in yearMonthArray"
                          :key="item.id"
                          :linkText="item.txt"
                          :elementId="item.id"
                          @clickHandler="setTradeYear"
                        >
                        </year-month-link>
                      </div>
                    </div>

                    <div class="row ms-1 mt-3 mb-2">
                      <div class="col-sm-3 offset-sm-4">
                        <div class="d-flex align-items-center gap-1">
                          <label class="form-label mb-0 me-1" for="tradeYear"
                            >Date or Year</label
                          >
                          <!-- class="form-control form-control-sm" -->
                          <input
                            id="tradeYear"
                            style="width: 120px"
                            v-model="tradeYear"
                          />
                          <button
                            class="btn btn-danger btn-sm me-3"
                            @click="tradeYear = ''"
                          >
                            <font-awesome-icon icon="fa-solid fa-trash" />
                          </button>
                          <span
                            >Profit&nbsp;{{
                              appUtils.formatCurrency(
                                getAllSums.sumAllProfitEur,
                                true
                              )
                            }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </base-card>
              </section>

              <table class="table table-striped table-dark">
                <thead>
                  <tr>
                    <!-- <th class="text-warning">Edit</th> -->

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="sortData('symbol', pageStore.setSortingTrade)"
                        >Symbol</a
                      >
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('description', pageStore.setSortingTrade)
                        "
                        >Description</a
                      >
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="sortData('buySell', pageStore.setSortingTrade)"
                        >BuySell</a
                      >
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('dateFormated', pageStore.setSortingTrade)
                        "
                        >Date</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="sortData('quantity', pageStore.setSortingTrade)"
                        >Quantity</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('tradePrice', pageStore.setSortingTrade)
                        "
                        >Price</a
                      >
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="sortData('currency', pageStore.setSortingTrade)"
                        >Currency</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('tradeMoney', pageStore.setSortingTrade)
                        "
                        >Money</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('fifoPnlRealized', pageStore.setSortingTrade)
                        "
                        >Profit Realized</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('fxRateToBase', pageStore.setSortingTrade)
                        "
                        >FX rate</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('fxRateToBase', pageStore.setSortingTrade)
                        "
                        >Profit EUR</a
                      >
                    </th>

                    <th class="text-warning" style="text-align: right">
                      Delete
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <trade-item
                    @select-id="selectId"
                    @delete-id="deleteId"
                    v-for="item in getAllTrades"
                    :key="item.guid"
                    :index="item.guid"
                    :guid="item.guid"
                    :symbol="item.symbol"
                    :description="item.description"
                    :buy-sell="item.buySell"
                    :trade-date="item.tradeDate"
                    :quantity="item.quantity"
                    :trade-price="item.tradePrice"
                    :currency="item.currency"
                    :trade-money="appUtils.fixCurrency(item.tradeMoney)"
                    :date-formated="item.dateFormated"
                    :fifo-pnl-realized="
                      appUtils.fixCurrency(item.fifoPnlRealized)
                    "
                    :fx-rate-to-base="item.fxRateToBase"
                    :show-active="'0'"
                    :selectedguid="getSelectedGuid"
                    :is-delete-visible="true"
                  ></trade-item>
                  <!-- v-model:active="item.active" -->

                  <tr>
                    <td colspan="5" style="text-align: right">
                      {{ getAllSums.sumAllQuantity }}
                    </td>

                    <td style="text-align: right">
                      {{ getAllSums.sumAvarageBuyPrice }}
                    </td>

                    <td colspan="2" style="text-align: right">
                      {{ getAllSums.sumAllMoney }}
                    </td>
                    <td style="text-align: right">
                      {{ getAllSums.sumAllProfit }}
                    </td>
                    <td style="text-align: right">&nbsp;</td>

                    <td style="text-align: right">
                      {{ getAllSums.sumAllProfitEur }}
                    </td>

                    <td style="text-align: right">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </base-card>
          </div>
        </div>
      </div>

      <!-- DIVIDENDS -->
      <div class="accordion-item bg-dark mt-2">
        <h2 class="accordion-header" id="heading4">
          <button
            class="accordion-button collapsed bg-dark"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapse4"
            aria-expanded="false"
            aria-controls="collapse4"
          >
            <h4 class="text-warning mt-1">Dividends</h4>
          </button>
        </h2>

        <div
          id="collapse4"
          class="accordion-collapse collapse"
          aria-labelledby="heading4"
        >
          <!-- DIVIDENDS -->
          <div class="accordion-body">
            <base-card class="bg-dark">
              <section class="ms-2">
                <base-year-selector
                  @changeYearComponent="changeYearParent"
                ></base-year-selector>
              </section>

              <section>
                <base-card class="bg-dark text-light">
                  <div>
                    Number of records: {{ Object.keys(getAllDividends).length }}
                  </div>
                  <div>
                    Sum of dividends:
                    {{
                      appUtils.formatCurrency(
                        getAllSums.sumDividendPositive,
                        true
                      )
                    }}
                  </div>
                  <div>
                    Sum of dividends tax:
                    {{
                      appUtils.formatCurrency(getAllSums.sumDividendTax, true)
                    }}
                  </div>

                  <div>
                    Sum of dividends after tax:
                    {{ appUtils.formatCurrency(getAllSums.sumDividend, true) }}
                  </div>
                </base-card>
              </section>

              <table class="table table-striped table-dark">
                <thead>
                  <tr class="text-warning">
                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('symbol', pageStore.setSortingDividend)
                        "
                        >Symbol</a
                      >
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="sortData('date', pageStore.setSortingDividend)"
                        >Dividend Date</a
                      >
                    </th>

                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('dividend', pageStore.setSortingDividend)
                        "
                        >Amount</a
                      >
                    </th>
                    <th style="text-align: right">
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('currency', pageStore.setSortingDividend)
                        "
                        >Currency</a
                      >
                    </th>
                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('description', pageStore.setSortingDividend)
                        "
                        >Description</a
                      >
                    </th>

                    <th>
                      <a
                        class="jr-link"
                        :href="null"
                        @click="
                          sortData('imported', pageStore.setSortingDividend)
                        "
                        >Imported</a
                      >
                    </th>

                    <th style="text-align: right">&nbsp;</th>
                  </tr>
                </thead>

                <tbody>
                  <dividend-item
                    v-for="item in getAllDividends"
                    @delete-id="deleteDividendId"
                    :key="item.guid"
                    :index="item.guid"
                    :guid="item.guid"
                    :symbol="item.symbol"
                    :description="item.description"
                    :currency="item.currency"
                    :date="item.date"
                    :dividend="item.dividend"
                    :imported="item.imported"
                  ></dividend-item>

                  <tr>
                    <td colspan="2">&nbsp;</td>
                    <td style="text-align: right">
                      {{ getAllSums.sumDividend }}
                    </td>
                    <td colspan="3">&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </base-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from 'moment';

//firebase
import { getDatabase } from 'firebase/database';

import { ref, computed, onMounted } from 'vue';
import appUtils from '../../components/utils/appUtils';

import {
  saveToFirebaseWithOptions,
  deleteFromFirebase,
} from '../../components/utils/firebaseUtils';
import TradeItem from '../../components/invest/TradeItem.vue';
import DividendItem from '../../components/invest/DividendItem.vue';
import TradeDashboardItem from '../../components/invest/TradeDashboardItem.vue';
import YearMonthLink from '../../components/invest/YearMonthLink.vue';

import { useInvestStore } from '../../stores/InvestStore';
import { loadFromFirebasePinia } from '../../components/utils/firebaseUtils';

const pageStore = useInvestStore();
let importText = ref('');
const deleteTitleGuid = ref('');

const deleteTitleGuidDesc = ref('');
const dataSorting = ref('');
const dataSortingOrder = ref('asc');
const selectedguid = ref('');
const sortOrder = ref('asc');
const searchText = ref(null);
const searchTrades = ref(null);
const searchTradesDate = ref(null);
const yearDividends = ref(null);

const showDeleteDialog = ref(null);
let pricesRef = ref([]);
let pricesAll = ref([]);
let sortField = ref('symbol');
let priceDate = ref();
let allowedDates = ref();
const isLoading = ref(false);

let dividendsRowsNumber = ref(0);

let modalMode = {
  TRADES: 'TRADES',
  DIVIDENDS: 'DIVIDENDS',
};

let actualMode = ref(null);

let yearMonthArray = [
  { id: 'year1', txt: appUtils.getCurrentYear(0) },
  { id: 'yearMonth0', txt: appUtils.getCurrentYearMonth(0) },
  { id: 'yearMonth1', txt: appUtils.getCurrentYearMonth(-1) },
  { id: 'yearMonth2', txt: appUtils.getCurrentYearMonth(-2) },
  { id: 'yearMonth3', txt: appUtils.getCurrentYearMonth(-3) },
  { id: 'yearMonth4', txt: appUtils.getCurrentYearMonth(-4) },
  { id: 'yearMonth5', txt: appUtils.getCurrentYearMonth(-5) },
  { id: 'yearMonth6', txt: appUtils.getCurrentYearMonth(-6) },
  { id: 'yearMonth7', txt: appUtils.getCurrentYearMonth(-7) },
  { id: 'yearMonth8', txt: appUtils.getCurrentYearMonth(-8) },
  { id: 'yearMonth9', txt: appUtils.getCurrentYearMonth(-9) },
  { id: 'yearMonth10', txt: appUtils.getCurrentYearMonth(-10) },
  { id: 'yearMonth11', txt: appUtils.getCurrentYearMonth(-11) },
  { id: 'year2', txt: appUtils.getCurrentYear(-1) },
];

let tradeYear = ref();

//const polygon_io_APIKEY = 'icmJf9pRcrRAIMnNVYTGynXiaY8Xgb4J';
// const selectedDate = ref(
//   appUtils.getCurrentYearMonth() +
//     '-' +
//     String(new Date().getDate()).padStart(2, '0')
// );
let onlySellActive = ref(false);
let onlyBuyActive = ref(false);
let searchOnlySymbol = ref(true);

const minDate = '2020-01-01';
const maxDate = appUtils.getCurrentYear(1) + '-12-31';
//const maxDate =  '2025-12-31';

const xmlLine = ref(
  '<Trade buySell="BUY" symbol="IWDA" tradeDate="28/03/2024" quantity="3.2814" tradePrice="91.423488" currency="EUR" tradeMoney="299.997033523" description="ISHARES CORE MSCI WORLD" dateTime="28/03/2024;12:20:46" netCash="-302.997033523" listingExchange="AEB" ibCommission="-3" ibCommissionCurrency="EUR" fxRateToBase="1" fifoPnlRealized="0" />'
);
const escapedXmlTrades = ref(
  xmlLine.value.replace(/</g, '&lt;').replace(/>/g, '&gt;')
);

// const xmlDividends = ref(
//   '<OpenDividendAccrual currency="USD" symbol="BEP" description="BROOKFIELD RENEWABLE PARTNER" isin="BMG162581083" issuerCountryCode="CA" payDate="27/09/2024" tax="0" fee="0" grossRate="0.34627" grossAmount="20.78" netAmount="20.78" />'
// );

// const escapedXmlDividends = ref(
//   xmlDividends.value.replace(/</g, '&lt;').replace(/>/g, '&gt;')
// );

onMounted(() => {
  console.log('onMounted');

  getAllPrices().then((snapshot) => {
    console.log(snapshot);
    let tmpObj = appUtils.getObjectCopy(snapshot.val());
    console.log(tmpObj);
    pricesAll.value = tmpObj;
    allowedDates.value = Object.keys(pricesAll.value);
    priceDate.value = allowedDates.value[allowedDates.value.length - 1];

    pricesRef.value = pricesAll.value[priceDate.value];
    // getPrices().then((snapshot) => {
    //   console.log(snapshot);
    //   let tmpObj = appUtils.getObjectCopy(snapshot.val());
    //   console.log(tmpObj);
    //   prices.value = tmpObj;
    // });

    // console.log(getPricesComp);

    setTradeYear(appUtils.getCurrentYear());
  });

  // pageStore.loadDividendsFirebase(null).then((snapshot) => {
  //   console.log(snapshot);
  // });

  //console.clear();
  // fetch(
  //   `https://api.polygon.io/v2/aggs/ticker/AAPL/prev?adjusted=true&apiKey=${polygon_io_APIKEY}`
  // )
  //   .then((response) => response.json())
  //   .then((response) => successx(response));
});

function changeYearParent(parYear) {
  console.log('changeYearParent:', parYear);
  pageStore.loadDividendsFirebase(null, parYear);
  yearDividends.value = parYear;
}

// function successx(response) {
//   var objString = JSON.stringify(response, null, 3);
//   console.log(response.results[0].c);
//   console.log(response);
//   console.log(objString);
// }

// const getPricesComputed = computed(function () {
//   return prices;
// });

const getDashboard = computed(function () {
  let uniqueSymbol = pageStore.getUniqueSymbols();
  let tmpTradesWithGuid = pageStore.tradesWithGuid;
  let dashboard = [];
  let sum = 0;
  let sumMoney = 0;
  let sumProfitRealized = 0;

  console.log('================ uniqueSymbol ================');
  console.log(uniqueSymbol);

  uniqueSymbol.forEach((item) => {
    sum = 0;
    sumMoney = 0;
    sumProfitRealized = 0;
    for (var i = 0; i < tmpTradesWithGuid.length; i++) {
      if (item.symbol == tmpTradesWithGuid[i].symbol) {
        sum += tmpTradesWithGuid[i].quantity;
        sumMoney += tmpTradesWithGuid[i].tradeMoney;
        sumProfitRealized += tmpTradesWithGuid[i].fifoPnlRealized;
      }
    }

    //sum > 0.000001 because of rounding - sometimes we ge some small sum like 1*e-14
    //sum < 0.00001 if there is a mistake in importing double trades for SELL then sum is negative
    if ((sum != 0 && sum > 0.000001) || sum < -0.00001) {
      let valueNow = 0;
      let priceNow = 0;

      if (pricesRef.value[item.symbol]) {
        try {
          valueNow = appUtils.fixCurrency(
            pricesRef.value[item.symbol].price * sum

            //getPricesComputed.value.value[item.symbol].price * sum
          );
          //        priceNow = getPricesComputed.value.value[item.symbol].price;
          priceNow = pricesRef.value[item.symbol].price;
        } catch (error) {
          console.log(error);
        }
        // } else {
        //   console.log('UNDEFINED', item.symbol);
      }

      dashboard.push({
        description: item.description,
        symbol: item.symbol,
        sum: appUtils.fixCurrency(sum, 4),
        sumMoney: appUtils.fixCurrency(sumMoney),
        valueNow,
        profit: appUtils.fixCurrency(valueNow - sumMoney - sumProfitRealized),
        priceNow,
      });
    }
  });

  if (searchText.value)
    dashboard = fastFilterAll(dashboard, searchText.value, [
      'description',
      'symbol',
    ]);

  console.log(' ============= dashboard =============');
  console.log(dashboard);

  return getSortedDashboard(dashboard);
});

const sumProfit = computed(function () {
  let dashboard = getDashboard;
  let sumProfit = 0;
  dashboard.value.forEach((item) => {
    sumProfit += item.profit;
  });
  sumProfit = appUtils.fixCurrency(sumProfit);

  return sumProfit;
});

const getSelectedGuid = computed(function () {
  if (selectedguid.value) {
    return selectedguid.value;
  } else {
    return '';
  }
});

const getAllTrades = computed(function () {
  let tmp = pageStore.tradesWithGuid;

  if (onlySellActive.value == true) {
    tmp = fastFilterAllGrids(['buySell'], tmp, 'SELL');
  } else if (onlyBuyActive.value == true) {
    tmp = fastFilterAllGrids(['buySell'], tmp, 'BUY');
  }
  if (searchText.value) {
    let fieldArr = [
      'description',
      'symbol',
      'buySell',
      'currency',
      'tradeDate',
    ];
    tmp = fastFilterAll(tmp, searchText.value, fieldArr);
  }
  if (tradeYear.value) {
    // console.log('=== HERE 1 ===');
    // console.log(tradeYear.value);

    let fieldArr = ['tradeDate'];
    tmp = fastFilterAll(
      tmp,
      tradeYear.value.replace('.', '/').replace('.', '/'),
      fieldArr
    );
  }

  return tmp;
});

const getAllSums = computed(function () {
  //calculate sum of fifoPnlRealized for all trades in filtered list
  let tmp = getAllTrades;
  let sumAllProfit = 0;
  let sumAllProfitEur = 0;
  let sumAllMoney = 0;
  let sumAllQuantity = 0;
  let sumAllBuy = 0;
  //let sumAllSell = 0;
  let sumAllBuyQty = 0;
  //let sumAllSellQty = 0;

  let sumAllDividend = 0;

  console.log(tmp);
  tmp.value.forEach((item) => {
    if (item.symbol == 'M3P' && item.buySell == 'SELL') console.log(item);

    sumAllProfit += item.fifoPnlRealized;
    sumAllProfitEur += item.fifoPnlRealized * item.fxRateToBase;
    sumAllMoney += item.tradeMoney;
    sumAllQuantity += item.quantity;
    //
    if (item.buySell == 'BUY') {
      sumAllBuyQty += item.quantity;
      sumAllBuy += item.tradeMoney - item.ibCommission;
      //sumAllBuy -= item.ibCommission;
    } else if (item.buySell == 'SELL') {
      //sumAllSellQty += item.quantity;
      //sumAllSell += item.tradeMoney;
      //sumAllBuy -= item.ibCommission;
    }
  });

  //geting sum of dividends
  let tmp1 = getAllDividends;
  let sumAllDividendTax = 0;
  let sumAllDividendPositive = 0;
  tmp1.value.forEach((item) => {
    sumAllDividend += item.dividend;
    if (item.dividend < 0) sumAllDividendTax += item.dividend;
    if (item.dividend > 0) sumAllDividendPositive += item.dividend;
  });

  let retObj = {
    sumAllProfit: appUtils.fixCurrency(sumAllProfit),
    sumAllProfitEur: appUtils.fixCurrency(sumAllProfitEur),
    sumAllMoney: appUtils.fixCurrency(sumAllMoney),
    sumAllQuantity: appUtils.fixCurrency(sumAllQuantity, 4),
    sumAvarageBuyPrice: appUtils.fixCurrency(sumAllBuy / sumAllBuyQty),
    sumDividend: appUtils.fixCurrency(sumAllDividend),
    sumDividendTax: appUtils.fixCurrency(sumAllDividendTax),
    sumDividendPositive: appUtils.fixCurrency(sumAllDividendPositive),
  };
  // console.log(sumAllBuyQty);
  // console.log(sumAllSellQty);
  // console.log(sumAllBuy);
  // console.log(sumAllSell);
  // console.log(retObj);

  return retObj;
});

function selectId(parObj) {
  console.log(parObj);
  selectedguid.value = parObj.guid;
}

function getImportDatetime() {
  return 'IMPORT ' + moment().format('YYYY.MM.DD HH:mm:ss');
}

/* IMPORT DIVIDENDS*/
async function importDividends() {
  subImportDividends2()
    .then(() => {
      pageStore
        .loadDividendsFirebase(null, appUtils.getCurrentYear())
        .then((snapshot) => {
          console.log(snapshot);
        });

      appUtils.showToast(
        'Dividends imported [' + dividendsRowsNumber.value + ']'
      );
    })
    .catch((error) => {
      throw error.message;
    });
}

const getAllDividends = computed(function () {
  let tmp = pageStore.dividendsWithGuid;
  if (searchText.value)
    tmp = fastFilterAll(tmp, searchText.value, ['description', 'symbol']);

  return tmp;
});

function importAddKey(tmpSymbol, tmpFullDate, keys, n) {
  tmpSymbol = tmpSymbol.replace('.', '-');

  var key = tmpSymbol + '-' + tmpFullDate;
  //key already exists we modify it
  if (keys.includes(key))
    key = tmpSymbol + '-' + n[0].toString() + '-' + tmpFullDate;
  keys.push(key);
  return key;
}

function subImportDividendsLine1(saveObj, tmp, keys, n) {
  if (tmp.length > 0 && tmp[4].includes('Cash') && tmp[4].includes('Div')) {
    n[0] += 1; //needs to be array since we don't wanna loose change outside of function
    var tmpSymbol = tmp[4].substring(0, tmp[4].indexOf('(')).trim();
    var tmpFullDate = tmp[5].substring(1, 11);
    var key = importAddKey(tmpSymbol, tmpFullDate, keys, n);
    var tmpDesc = tmp[4];

    let plusMinus = 1;
    if (Number(tmp[8] < 0)) {
      plusMinus = -1;
      tmpDesc += ' [Withholding Tax in EUR]';
    }

    saveObj[key] = {
      symbol: tmpSymbol,
      date: tmpFullDate,
      dividend: plusMinus * Number(tmp[9].replace(',', '')),
      currency: 'EUR',
      description: tmpDesc,
      imported: getImportDatetime(),
    };
  }
}

function subImportDividendsLine2(saveObj, tmp, keys, n) {
  if (tmp.length > 0) {
    //currency needs to be EUR or. USD + contains 'Withholding @'

    let ret = false;
    if (tmp[2] != 'EUR') ret = true;

    if (ret == true && tmp[2] == 'USD' && tmp[4].includes('Withholding @')) {
      //we don't have EUR than we check if we have USD and contains 'Withholding @'
      ret = false;
    }

    if (ret == true) return;

    n[0] += 1; //needs to be array since we don't wanna loose change outside of function

    var tmpSymbol = tmp[4].substring(0, tmp[4].indexOf('(')).trim();
    var key; //= importAddKey(tmpSymbol, tmp[3], keys, n);
    if (tmp[4].includes('Withholding @')) {
      //this is tricky
      tmpSymbol = 'CREDIT-INTEREST-TAX';
      key = importAddKey(tmpSymbol, tmp[3], keys, n);
    } else {
      key = importAddKey(tmpSymbol, tmp[3], keys, n);
    }

    if (tmpSymbol != '') {
      var tmpDesc = tmp[4];
      if (tmpDesc.includes(' Tax') && tmp[0].includes('Withholding Tax')) {
        tmpDesc += ' [Withholding Tax in EUR]';
      }

      let FXrate = 1;
      if (tmpDesc.includes('Withholding @') && tmp[2] == 'USD') {
        tmpDesc +=
          ' [original currency ' +
          Number(tmp[5].replace(',', '')) +
          ' ' +
          tmp[2] +
          ']';
        FXrate = findFXforUSD(tmp[3]);
        tmp[2] = 'EUR';
      }

      saveObj[key] = {
        symbol: tmpSymbol,
        date: tmp[3],
        dividend: appUtils.fixCurrency(
          FXrate * Number(tmp[5].replace(',', '')),
          6
        ),
        currency: tmp[2],
        description: tmpDesc,
        imported: getImportDatetime(),
      };
    }
  }
}

function findFXforUSD(parDate) {
  var lines = importText.value.split('\n');
  var ret = 1;
  //we are loking for such line:
  //Forex P/L Details,Data,Forex,EUR,Net cash activity,2025-01-06,USD,9.9,9.528354,-9.528354,0,O

  for (let i = 0; i < lines.length; i++) {
    if (lines[i] != '') {
      var tmp = lines[i].split(',');
      if (tmp.length > 0) {
        if (
          tmp[0].includes('Forex P/L Details') &&
          tmp[4].includes('Net cash activity')
        ) {
          if (tmp[5] == parDate && tmp[6] == 'USD') {
            ret = 0.3333;
            ret = Math.abs(tmp[8] / tmp[7]);
            break;
          }
        }
      }
    }
  }
  return ret;
}

function getYearDividend() {
  var lines = importText.value.split('\n');
  var tmpDateYear;

  //lets find the year for which we are importing dividends
  for (let i = 0; i < 15; i++) {
    if (lines[i].includes('Statement,Data,Period')) {
      tmpDateYear = lines[i].split(',');
      return tmpDateYear[5].replace('"', '').trim();
    }
  }
  return appUtils.getCurrentYear();
}

async function subImportDividends2() {
  try {
    dividendsRowsNumber.value = 0;

    var lines = importText.value.split('\n');
    var tmpDateYear = getYearDividend();

    let optionObj = { url: `invest_dividends/{uid}/${tmpDateYear}` };
    let saveObj = {};
    let keys = [];

    let n = [0]; //needs to be array since we don't wanna loose change when calling other function
    for (let i = 0; i < lines.length; i++) {
      if (lines[i] != '') {
        var tmp = lines[i].split(',');
        if (tmp.length > 0) {
          if (tmp[0].includes('Forex P/L Details')) {
            subImportDividendsLine1(saveObj, tmp, keys, n);
          } else if (
            tmp[0].includes('Dividends') ||
            tmp[0].includes('Withholding Tax')
          ) {
            subImportDividendsLine2(saveObj, tmp, keys, n);
          }
        }
      }
    }

    dividendsRowsNumber.value = Object.keys(saveObj).length;
    saveToFirebaseWithOptions(optionObj, saveObj).then(() => {});

    console.log('subImportDividends2 => saveObj');
    console.log(optionObj);
    console.log(saveObj);
  } catch (error) {
    console.log(error);
  }
}

/* IMPORT TRADES */
async function importTrades() {
  subImportTrades()
    // .then(() => emit('importdone'))
    .then(() => {
      console.log('importdone');
      //appUtils.showToast(`Trades imported!` );
      appUtils.showToast('Trades imported [' + dividendsRowsNumber.value + ']');
    })
    .catch((error) => {
      throw error.message;
    });
}

function getTradesFromXML(xmlDoc) {
  let xmlTrades;
  const parentTag = xmlDoc.getElementsByTagName('FlexStatements')[0];
  if (parentTag) {
    const childTag = parentTag.getElementsByTagName('FlexStatement')[0];
    if (childTag) xmlTrades = childTag.getElementsByTagName('Trades')[0];
  }
  return xmlTrades;
}

async function subImportTrades() {
  //console.log(tmpRemark);
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(importText.value, 'text/xml');
  const xmlTrades = getTradesFromXML(xmlDoc);

  var tradeNodes = xmlTrades.childNodes;
  let optionObj = { url: `invest_trades/{uid}/{newKey}` };

  dividendsRowsNumber.value = 0;

  let saveObj;
  for (var element in tradeNodes) {
    if (tradeNodes[element].tagName == 'Trade') {
      if (
        tradeNodes[element].attributes.symbol.value != 'EUR.USD' &&
        tradeNodes[element].attributes.symbol.value != 'USD.EUR'
      ) {
        saveObj = getSaveObjTrades(tradeNodes[element].attributes);
        // console.log(saveObj);
        saveObj.importTime = getImportDatetime();

        dividendsRowsNumber.value += 1;

        saveToFirebaseWithOptions(
          optionObj,
          saveObj,
          pageStore.loadInvestFirebase
        ).then(() => {
          console.log('IMPORT DONE');
        });
      }
    }
  }
}

function getSaveObjTrades(pAttributes) {
  let saveObj = {};

  saveObj.buySell = pAttributes.buySell.value;
  saveObj.symbol = pAttributes.symbol.value;
  saveObj.tradeDate = pAttributes.tradeDate.value;
  saveObj.quantity = Number(pAttributes.quantity.value);
  saveObj.tradePrice = Number(pAttributes.tradePrice.value);
  saveObj.currency = pAttributes.currency.value;
  saveObj.tradeMoney = Number(pAttributes.tradeMoney.value);
  saveObj.dateTime = pAttributes.dateTime.value;
  saveObj.description = pAttributes.description.value;
  saveObj.netCash = Number(pAttributes.netCash.value);
  saveObj.listingExchange = pAttributes.listingExchange.value;
  saveObj.ibCommission = Number(pAttributes.ibCommission.value);
  saveObj.ibCommissionCurrency = pAttributes.ibCommissionCurrency.value;
  saveObj.fxRateToBase = Number(pAttributes.fxRateToBase.value);
  saveObj.fifoPnlRealized = Number(pAttributes.fifoPnlRealized.value);

  //saveObj.dateFormated = appUtils.getDateAsString(saveObj.tradeDate);

  saveObj.dateFormated = appUtils.getFormatedDate2(saveObj.tradeDate, '/', '-');

  saveObj.symbol = saveObj.symbol.replace('CNDX', 'SXRV');
  saveObj.symbol = saveObj.symbol.replace('R2US', 'ZPRR');
  saveObj.symbol = saveObj.symbol.replace('CSPX', 'SXR8');
  saveObj.symbol = saveObj.symbol.replace('VNAd', 'VNA');

  return saveObj;
}

function fastFilterAllGrids(fieldArr, tmp, searchText) {
  return tmp.filter(
    appUtils.fastFilterGeneral.bind(this, searchText, fieldArr)
  );
}

function fastFilterAll(tmp, searchText, fieldArr) {
  console.log('fastFilterAll=>searchText', searchText);

  if (searchOnlySymbol.value == true) {
    fieldArr = ['symbol'];
    searchText = searchText + '#EXACT#';
  }
  return fastFilterAllGrids(fieldArr, tmp, searchText);
}

function handleCloseShowDelete() {
  showDeleteDialog.value = null;
  deleteTitleGuid.value = null;
}

function deleteDividendId(dividendGuid) {
  actualMode.value = modalMode.DIVIDENDS;

  let tmpDividendsWithGuid = pageStore.dividendsWithGuid;
  const itemToByDeleted = tmpDividendsWithGuid.find(
    (x) => x.guid === dividendGuid
  );
  console.log('itemToByDeleted: ', itemToByDeleted);
  console.log(`dividendGuid: ${dividendGuid}`);

  showDeleteDialog.value = true;
  deleteTitleGuid.value = dividendGuid;

  if (itemToByDeleted) {
    deleteTitleGuidDesc.value = '<br />';
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.symbol,
      'Symbol'
    );

    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.date,
      'Date',
      true
    );

    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.dividend,
      'Amount'
    );

    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.currency,
      'Currency'
    );

    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.description,
      'Description'
    );

    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.imported,
      'Imported'
    );
  }
}

function deleteId(transGuid) {
  actualMode.value = modalMode.TRADES;

  showDeleteDialog.value = true;
  deleteTitleGuid.value = transGuid;

  let tmpTradesWithGuid = pageStore.tradesWithGuid;

  const itemToByDeleted = tmpTradesWithGuid.find((x) => x.guid === transGuid);
  console.log('itemToByDeleted: ', itemToByDeleted);

  if (itemToByDeleted) {
    deleteTitleGuidDesc.value = '<br />';
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.symbol,
      'Symbol'
    );

    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.description,
      'Description'
    );
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.buySell,
      'BuySell'
    );
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.tradeDate,
      'Date',
      true
    );
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.quantity,
      'Quantity'
    );
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.tradePrice,
      'Price'
    );
    deleteTitleGuidDesc.value += appUtils.formatTextForDialog(
      itemToByDeleted.currency,
      'Currency'
    );
  }
}

function deleteIdActual() {
  const X = window.scrollX;
  const Y = window.scrollY;
  let tmpGuid = deleteTitleGuid.value;

  console.log('actualMode.value', actualMode.value);

  if (deleteTitleGuid.value && actualMode.value === modalMode.TRADES) {
    //deleting Trade record
    let optionObj = { url: `invest_trades/{uid}/${deleteTitleGuid.value}` };

    console.log(`invest_trades/{uid}/${deleteTitleGuid.value}`);

    deleteFromFirebase(optionObj, pageStore.loadInvestFirebase).then(() => {
      //scrolling back to previous position
      window.scrollTo(X, Y);
      // appUtils.showToast('Trade Deleted');
      appUtils.showToast('Trade with ID ' + tmpGuid + ' is deleted!');
    });
  } else if (
    deleteTitleGuid.value &&
    yearDividends.value &&
    actualMode.value === modalMode.DIVIDENDS
  ) {
    //deleting Dividend record
    let optionObj = {
      url: `invest_dividends/{uid}/${yearDividends.value}/${deleteTitleGuid.value}`,
    };

    console.log(
      `invest_dividends/{uid}/${yearDividends.value}/${deleteTitleGuid.value}`
    );

    deleteFromFirebase(optionObj).then(() => {
      //scrolling back to previous position

      changeYearParent(yearDividends.value);

      window.scrollTo(X, Y);
      appUtils.showToast('Dividend with ID ' + tmpGuid + ' is deleted!');
    });
  }

  handleCloseShowDelete();
}

function fOrder(field) {
  if (field == sortField.value) {
    if (sortOrder.value == 'asc') sortOrder.value = 'desc';
    else sortOrder.value = 'asc';
  } else sortOrder.value = 'asc';
  sortField.value = field;
}

function sortData(field, pageStoreAction, reload = false) {
  console.log(
    `sortData | field=${field} | dataSorting=${dataSorting.value} | dataSortingOrder=${dataSortingOrder.value}`
  );

  let callSorting = false;

  if (reload) {
    if (field == dataSorting.value) {
      if (dataSortingOrder.value == 'asc') {
        dataSortingOrder.value = 'desc';
      } else {
        dataSortingOrder.value = 'asc';
      }
      callSorting = true;
    }
  } else {
    callSorting = true;
  }

  if (callSorting)
    appUtils.setSortingParamsProto(
      field,
      dataSorting,
      dataSortingOrder,
      pageStoreAction
    );
}

function getSortedDashboard(dashboard) {
  if (sortField.value == 'symbol') {
    return dashboard.sort((a, b) =>
      appUtils.sortByKey1(a, b, sortField.value, sortOrder.value)
    );
  } else {
    if (sortOrder.value == 'asc') {
      dashboard.sort(function (a, b) {
        return a[sortField.value] - b[sortField.value];
      });
    } else {
      dashboard.sort(function (a, b) {
        return b[sortField.value] - a[sortField.value];
      });
    }
  }
  return dashboard;
}

async function importPrices() {
  try {
    var lines = importText.value.split('\n');
    var tmpDate = moment().format('YYYY-MM-DD');
    //tmpDate = '2024-12-31';

    let optionObj = {
      url: `invest_prices/{uid}/${tmpDate}`,
    };

    let dontImport = ['ETHE', 'MATIC', 'MMAT', 'OMG', 'SAND'];

    let saveObj = {};
    for (let i = 0; i < lines.length; i++) {
      if (lines[i] != '') {
        var tmp = lines[i].split('\t');
        if (tmp.length > 0 && !tmp[1].includes('N/A')) {
          var tmpSymbol = tmp[0].replace('.', '-');

          if (dontImport.includes(tmpSymbol) == false) {
            saveObj[tmpSymbol] = {
              price: Number(tmp[1].replace(',', '')),
              currency: tmp[2],
            };
          }
        }
      }
    }

    // console.log('subImportPrices => saveArr');
    // console.log(saveArr);

    saveToFirebaseWithOptions(optionObj, saveObj).then(() => {
      appUtils.showToast(
        `Prices imported [count=${Object.keys(saveObj).length}] !`
      );

      getAllPrices().then((snapshot) => {
        // console.log(snapshot);
        let tmpObj = appUtils.getObjectCopy(snapshot.val());
        // console.log(tmpObj);
        pricesAll.value = tmpObj;
        allowedDates.value = Object.keys(pricesAll.value);
        priceDate.value = allowedDates.value[allowedDates.value.length - 1];
        pricesRef.value = pricesAll.value[priceDate.value];
      });
    });
  } catch (error) {
    console.log(error);
  }
}

function setclass(profit) {
  if (profit > 0) return 'bg-profit';
  return 'bg-profit-minus';
}

function getAllPrices() {
  return loadFromFirebasePinia({}, 'invest_prices');
}

function ondatechangehere(eventArgs) {
  priceDate.value = appUtils.getDateAsString(eventArgs);
  pricesRef.value = pricesAll.value[priceDate.value];
}

function showOnlySell() {
  onlySellActive.value = !onlySellActive.value;
  if (onlySellActive.value == true) onlyBuyActive.value = false;
}

function showOnlyBuy() {
  onlyBuyActive.value = !onlyBuyActive.value;
  if (onlyBuyActive.value == true) onlySellActive.value = false;
}

function searchOnSymbolOnly() {
  searchOnlySymbol.value = !searchOnlySymbol.value;
}

function setTradeYear(par) {
  searchOnlySymbol.value = false;
  let [year, month] = par.split('-');

  if (month) {
    month.padStart(2, '0'); // ensure two digits
    tradeYear.value = month + '.' + year;
  } else tradeYear.value = year;
}

async function searchTradesFirebase() {
  isLoading.value = true;
  const db = getDatabase();

  let searchObj = {};
  if (searchTrades.value) {
    searchObj = { symbol: searchTrades.value };
  } else if (searchTradesDate.value) {
    searchObj = { dateFormated: searchTradesDate.value };
  }

  pageStore
    .loadInvestTradesFirebase({
      db,
      searchObj: searchObj,
    })
    .then(() => {})
    .catch((error) => console.log(error))
    .finally(() => {
      tradeYear.value = '';

      if (searchObj.dateFormated) {
        if (searchObj.dateFormated.length == 4) {
          //specific year
          setTradeYear(searchObj.dateFormated);
        } else if (searchObj.dateFormated.length == 7) {
          //specific month
          setTradeYear(searchObj.dateFormated);
        } else if (searchObj.dateFormated.length == 10) {
          //specific date
          setTradeYear(searchObj.dateFormated.substring(0, 7));
        }
      } else if (searchObj.symbol) {
        tradeYear.value = '';
        //setTradeYear(appUtils.getCurrentYear());
      }

      delay(100).then(() => {
        isLoading.value = false;
      });

      console.log('finally => searchTradesFirebase()');
    });
}

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
</script>

<style>
.active1 {
  background-color: blue;
  color: white;
}
</style>
